import styled from 'styled-components'
import { COLORTEXT } from '../style'

export const Search = styled.div`

margin-top: 80px;
user-select: none;
`
export const Search2 = styled.div`
user-select: none;
`

export const Nav = styled.div`

color: ${COLORTEXT};
background: black;
font-size: 2rem;
position: sticky;
margin: auto;
margin-top:-80px;
top: 0;
z-index: 10;
box-shadow: 0px 6px 6px -6px black;
`
export const Nav2 = styled.div`
color: ${COLORTEXT};
background: rgba(73, 72, 72, 1);
font-size: 2rem;
position: sticky;
margin: auto;
margin-top:-80px;
top: 0;
z-index: 10;
box-shadow: 0px 6px 6px -6px black;
filter: none;
`

export const NavCon = styled.div`
display: flex;
flex-wrap: wrap;
justify-content: space-evenly;
`

export const NavRow = styled.div`
text-align: center;
color: #fff;
filter: none;
`
export const Navbtn = styled.div`
color: #fff;
`

export const Btn = styled.button`
font-family: 'Raleway', sans-serif;
font-weight: 500;
background-color: transparent;
color: grey;
font-size: 1.25rem;
border: transparent;
&:hover {
color: white;
}
@media screen and (max-width: 700px){
    font-size: 0.8rem;
}
`